import { AlertAdapter, RegularButton } from 'pg-ui-library';
import React from 'react';
import ReactModal from 'react-modal';
import { useTranslation } from 'react-i18next';
import { CloseIcon } from 'src/modules/login/components/mfa-modal/styles';
import closeSvg from 'src/assets/close.svg';
import { useFormik } from 'formik';
import { useLeaveStatusChange } from '../mutations/leave-update';

import { ReopenTicketForm, LeaveModalConfimrationHeader, ReopenFooter, ConfirmationQues } from './styles';

export const LeaveConfimrationModal: React.FC<{
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  leaveStatusChange: any;
  refetch: any;
  setSelectedRows: any;
  // eslint-disable-next-line react/prop-types
}> = ({ isOpen, setIsOpen, leaveStatusChange, refetch, setSelectedRows }) => {
  const { t } = useTranslation();
  const leaveStatusChangeSubmit = useLeaveStatusChange();

  const handleModal = () => {
    setIsOpen(!isOpen);
  };

  const { status } = leaveStatusChange;

  let modalHeader = '';
  let buttonText = '';
  let confirmationMessage = '';

  if (status === 'Approved') {
    modalHeader = 'Confirm Leave Application Approval';
    buttonText = 'Approve';
    confirmationMessage =
      'Are you sure you want to approve this leave application? Once approved, the leave will be recorded, and the employee will be notified.';
  } else if (status === 'Pending') {
    modalHeader = 'Confirm Leave Application Set to Pending';
    buttonText = 'Set to Pending';
    confirmationMessage =
      'Are you sure you want to set this leave application to Pending? The employee will be notified about the change.';
  } else if (status === 'Rejected') {
    modalHeader = 'Confirm Leave Application Rejection';
    buttonText = 'Reject';
    confirmationMessage =
      'Are you sure you want to reject this leave application? The employee will be notified about the rejection.';
  }

  const formik = useFormik({
    initialValues: {
      description: '',
    },
    onSubmit: async () => {
      await leaveStatusChangeSubmit.mutateAsync({ leaveStatus: leaveStatusChange });
      AlertAdapter('Leave status is change succesfully', 'success');
      refetch();

      setIsOpen(!isOpen);
      setSelectedRows([]);
    },
  });

  return (
    // eslint-disable-next-line react/react-in-jsx-scope
    <ReactModal
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={handleModal}
      style={{
        overlay: {
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          borderRadius: '30px',
          margin: 'auto',
          width: '680px',
          height: '260px',
          display: 'flex',
          flexDirection: 'column',
          padding: '0 30px 0 30px',
          background: '#F3F4F8',
          overflowY: 'hidden',
        },
      }}
    >
      <ReopenTicketForm onSubmit={formik.handleSubmit}>
        <LeaveModalConfimrationHeader>
          <div>
            <h3>{modalHeader}</h3>
          </div>
          <div style={{ marginTop: '30px' }}>
            <CloseIcon src={closeSvg} onClick={() => handleModal()} />
          </div>
        </LeaveModalConfimrationHeader>
        <ConfirmationQues>
          <p>{confirmationMessage}</p>
        </ConfirmationQues>
        <ReopenFooter>
          <RegularButton onClick={handleModal} style={{ color: '#4948AC', backgroundColor: '#fff' }}>
            {t('global.form.cancel')}
          </RegularButton>
          <RegularButton disabled={formik.isSubmitting} type="submit">
            {buttonText}
          </RegularButton>
        </ReopenFooter>
      </ReopenTicketForm>
    </ReactModal>
  );
};
